module.exports = __webpack_public_path__ + "img/tree_view_linux_go_folder.6d2f6d8c.png";